import { apiService } from '.';
import {
    Alerts,
    AlertsFilter,
    AlertsHistorical,
    AlertTemplateFilter,
} from '../shared/types/legalProceedings/alerts';
import { Template } from '../shared/types/template';

export const asyncGetAlerts = async (
    filters: AlertsFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Alerts[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Alerts[]; length: number };
        } = await apiService.get('/api/alert', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncCreateAlert = async (
    alert: Alerts
): Promise<Alerts | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Alerts;
        } = await apiService.post('/api/alert', alert);

        return data;
    } catch (error) {}
};

export const asyncGetAlert = async (
    idAlert: string
): Promise<Alerts | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Alerts;
        } = await apiService.get(`/api/alert/${idAlert}`);

        return data;
    } catch (error) {}
};

export const asyncUpdateAlert = async (
    id: string,
    alert: Alerts
): Promise<Alerts | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Alerts;
        } = await apiService.patch(`/api/alert/${id}`, alert);

        return data;
    } catch (error) {}
};

export const asyncGetAlertHistorical = async (
    id: string
): Promise<AlertsHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: AlertsHistorical[];
        } = await apiService.get(`/api/alert/${id}/historical`);
        return data;
    } catch (error) {}
};

export const asyncGetTemplate = async (
    filters: AlertTemplateFilter
): Promise<Template | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Template;
        } = await apiService.get('/api/alert/template', filters);
        return data;
    } catch (error) {}
};
